import SubCategoryGrid from "@/components/SubCategoryGrid.vue";
export const subCategoryGridInit = {
    component: SubCategoryGrid,
    name: "SubCategoryGrid",
    canHaveChildren: true,
    inputs: [
        {
            name: "images",
            type: "list",
            defaultValue: [{ mapped_subcategory: "", media: "" }],
            subFields: [
                {
                    name: "mapped_subcategory",
                    type: "string"
                },
                {
                    name: "media",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"]
                }
            ]
        },
        {
            name: "cards_per_row",
            type: "string",
            default: "3",
            enum: ["1", "2", "3", "4", "5"]
        },
        {
            name: "gap_between_cards",
            type: "boolean",
            default: true
        }
    ]
};
